(() => {
  const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));
  const nextOffset = (current, viewport, scrollWidth, direction) => clamp(current + (viewport * .86 * direction), 0, Math.max(0, scrollWidth - viewport));
  window.ApellaProductRecommendationsModel = Object.freeze({ clamp, nextOffset });

  class ApellaProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.querySelectorAll('.apella-recommendations__rail').forEach((rail) => this.bindRail(rail));
    }

    bindRail(rail) {
      const track = rail.querySelector('[data-recommendation-track]');
      const previous = rail.querySelector('[data-recommendation-previous]');
      const next = rail.querySelector('[data-recommendation-next]');
      if (!track || !previous || !next) return;
      const update = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };
      const move = (direction) => track.scrollTo({ left: nextOffset(track.scrollLeft, track.clientWidth, track.scrollWidth, direction), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    }
  }
  if (!customElements.get('apella-product-recommendations')) customElements.define('apella-product-recommendations', ApellaProductRecommendations);
})();
